<template>
    <div class="route-options">
        <h6 class="title">
            Travel via
        </h6>
        <template v-for="(route, index) in value.via">
            <div :key="'via-route-' + index" class="route">
                <StationPicker
                    :start-value="route.station.name"
                    @pick="name => {route.station = name; updateModel();}"
                    @emptied="() => {route.station = blankRoute().station; updateModel();}"
                ></StationPicker>
                <radio-selectors v-model="route.method" :options="config.options.method.via"></radio-selectors>
            </div>
            <div v-if="route.method[0] === 'C'" :key="'via-route-time-' + index" class="extra-mins">
                <label>
                    extra mins
                    <input v-model="route.extra" class="input" type="text">
                </label>
            </div>
        </template>
        <h6 class="title mt-2">
            Avoid
        </h6>
        <template v-for="(route, index) in value.avoid">
            <div :key="'avoid-route-' + index" class="route">
                <StationPicker
                    :start-value="route.station.name"
                    @pick="name => {route.station = name; updateModel();}"
                    @emptied="() => {route.station = blankRoute().station; updateModel();}"
                ></StationPicker>
                <radio-selectors v-model="route.method" :options="config.options.method.avoid"></radio-selectors>
            </div>
        </template>
    </div>
</template>

<script>
    import RadioSelectors from './RadioSelectors';
    import StationPicker from './StationPicker';

    export default {
        name: 'RouteOptions',
        components: {
            RadioSelectors,
            StationPicker,
        },
        props: {
            value: {
                type: Object,
                default() {
                    return {
                        via: [],
                        avoid: [],
                    };
                },
            },
            config: {
                type: Object,
                default() {
                    return {
                        label: 'Route Options',
                        options: {
                            stations: [],
                            method: {
                                via: [],
                                avoid: [],
                            },
                        },
                    };
                },
            },
        },
        methods: {
            updateModel() {
                const newValue = this.value;
                const viaLength = newValue.via.length;
                const avoidLength = newValue.avoid.length;
                if (viaLength < 3 && newValue.via[viaLength - 1].station.key.length > 0) {
                    newValue.via = newValue.via.concat(this.blankRoute());
                }
                if (avoidLength < 3 && newValue.avoid[avoidLength - 1].station.key.length > 0) {
                    newValue.avoid = newValue.avoid.concat(this.blankRoute());
                }
            },
            addNewVia() {
                const newVal = this.value;
                newVal.via[newVal.via.length] = this.encode(this.newVia);
                this.$emit('input', newVal);
                this.newVia = this.blankRoute();
            },
            addNewAvoid() {
                const newVal = this.value;
                newVal.avoid[newVal.avoid.length] = this.encode(this.newAvoid);
                this.$emit('input', newVal);
                this.newAvoid = this.blankRoute();
            },
            blankRoute() {
                return {
                    station: {
                        name: '',
                        key: '',
                    },
                    method: [
                        'P',
                    ],
                    extra: 0,
                };
            },
        },
    };
</script>
